import { auth } from "../firebase";
import i18n from "../i18n";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8080";

async function authHeader() {
  const u = auth.currentUser;
  if (!u) return {};
  const token = await u.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

export async function chatRequest(payload) {
  const headers = await authHeader();

  const res = await fetch(`${API_BASE}/chat`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify({
      ...payload,
      lang: i18n.language || "uk",
    }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || data?.message || `HTTP ${res.status}`);
  }
  return data;
}

export async function loadChatHistory(externalId) {
  const headers = await authHeader();

  const res = await fetch(`${API_BASE}/me/chat/${externalId}`, {
    method: "GET",
    headers,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || data?.message || `HTTP ${res.status}`);
  }
  return data;
}

export async function saveChatMessage(chatId, message) {
  const headers = await authHeader();

  const res = await fetch(
    `${API_BASE}/me/chat/${encodeURIComponent(chatId)}/messages`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: JSON.stringify(message),
    }
  );

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || data?.message || `HTTP ${res.status}`);
  }
  return data;
}